export const CANDIDATES_PROFILE_HASHES = Object.freeze({
  EstablishingUrgency: 'establishingUrgency'
});
